export default __webpack_public_path__ + "static/media/soldier-teamheal.69123907.mp3";